export { default as About } from './about/About';
export { default as Hero } from './hero/Hero';
export { default as Work } from './work/Work';
export { default as Testamonials } from './testamonials/Testamonials';
export { default as Clients } from './clients/Clients';
export { default as Contact } from './contact/Contact';
